import gsap from "gsap/all";

class Numbers {
    constructor() {
        this.DOM = document.querySelector('.c-numbers')
        this.animateOnScroll();
    }
    animateOnScroll() {
        const items = this.DOM.querySelectorAll('.c-numbers__item')
        const list = this.DOM.querySelector('.c-numbers__list');
        
        gsap.from(items, {
            scrollTrigger: list,
            autoAlpha: 0,
            y: 25,
            duration: 0.75,
            stagger: 0.25
          });
    }
}


export default function ComponentNumbers() {
    const compNumbers = document.querySelectorAll('.c-numbers');
    if (compNumbers.length > 0) {
        compNumbers.forEach(comp => new Numbers(comp))
    } 
}


